import { useNavigationStore } from "src/store/navigationStore";
import { useHexagonSize } from "src/hooks/useHexagonSize";
import NavigationTopView from "../navigation/navigation-top-view";
import { useAppStore } from "@/store/appStore";
import { CHAT_TYPE } from "@/types/navigation-mode";
import CrimeSceneTopView from "../crimeScene/crimeScene-top-view";
import ExplorationTopView from "../exploration/exploration-top-view";
import ModelViewerTopView from "../modelViewer/modelViewer-top-view";

export default function TopViewButton() {
  const chatType = useAppStore((state) => state.chatType);

  const isShowTopViewNavigation = useNavigationStore(
    (state) => state.isShowTopViewNavigation
  );
  const setIsShowTopViewNavigation = useNavigationStore(
    (state) => state.setIsShowTopViewNavigation
  );

  const toggleTopView = () => {
    setIsShowTopViewNavigation(!isShowTopViewNavigation);
  };

  const {
    HEX_WIDTH_OUTER,
    HEX_HEIGHT_OUTER,
    HEX_WIDTH_BTN_BG,
    HEX_HEIGHT_BTN_BG,
  } = useHexagonSize();

  // Conditionally render the button or a div based on the flag
  return (
    <div
      className={`relative ${isShowTopViewNavigation ? "" : "flex items-end"}`}
      style={{ width: `${HEX_WIDTH_OUTER}px`, height: `${HEX_HEIGHT_OUTER}px` }}
    >
      {isShowTopViewNavigation ? (
        <>
          {/* Big hexagon div */}
          <div
            className="absolute hex-bg"
            style={{
              width: `${HEX_WIDTH_OUTER}px`,
              height: `${HEX_HEIGHT_OUTER}px`,
            }}
          >
            <div
              id="navigation-top-view-parent"
              className="relative flex items-center justify-center"
              style={{
                width: `${HEX_WIDTH_OUTER}px`,
                height: `${HEX_HEIGHT_OUTER}px`,
              }}
            >

              {chatType === CHAT_TYPE.NAVIGATION ? (
                <NavigationTopView />
              ) : chatType === CHAT_TYPE.SIMULATION ? (
                <CrimeSceneTopView />
              ) : chatType === CHAT_TYPE.EXPLORATION ? (
                <ExplorationTopView />
              ) : chatType === CHAT_TYPE.MODELVIEWER ? (
                <ModelViewerTopView />
              ) : <></>
              }
            </div>

            {/* Arrow button */}
            <div
              className="absolute left-0 bottom-0 hex-bg flex items-center justify-center"
              style={{
                width: `${HEX_WIDTH_BTN_BG}px`,
                height: `${HEX_HEIGHT_BTN_BG}px`,
              }}
              onClick={() => {
                setIsShowTopViewNavigation(false);
              }}
            >
              <div
                className="relative cursor-pointer"
                onClick={() => {
                  setIsShowTopViewNavigation(false);
                }}
              >
                <img
                  src="/assets/icon_down_arrow.png"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        <div
          className="absolute map-btn-bg w-[42px] h-[46px] md:w-[63px] md:h-[69px] flex items-center justify-center"
          onClick={() => {
            setIsShowTopViewNavigation(true);
          }}
        ></div>
      )}
    </div>
  );
}
